module.exports = __webpack_public_path__ + "img/lset-icon.d3bf7b3e.png";